import React, { useState, useEffect } from "react";
import { get } from "lodash";
import { Field } from "redux-form";
import { useParams, useNavigate } from "react-router-dom";
import { required, email, confirmation, length } from "redux-form-validators";

import { scrollToTop } from "../../../../helpers/animation";
import { Button, Checkbox, Input } from "../../../../components/Field";
import { getPasswordValidationRegex } from "../../../../helpers/input";
import Link from "../../../../components/Link";
import Text from "../../../../components/Text";
import AsyncGet from "../../../../components/AsyncGet";
import AsyncForm from "../../../../components/AsyncForm";

import style from "../style.module.css";

export default function PersonalDetails({ nextStep, personalDetails = {}, setPersonalDetails, setUrlHash, setPlanId }) {
    const Params = useParams();
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const urlhash = get(Params, "hash", "");
    setUrlHash(urlhash);
    useEffect(() => {
        if (!urlhash) {
            navigate("/register", { replace: true });
        }
    }, [urlhash, navigate]);

    return (
        <div className={style.personalDetails}>
            <AsyncGet
                url="/verify-redeem-hash"
                permissionText={false}
                loadOnMount={true}
                method="post"
                paramsData={{ email_hash: urlhash }}
                render={({ data }) => {
                    if (data.id) {
                        setPlanId(data.membership_id);
                        return (
                            <AsyncForm
                                id="grstep01"
                                url="/redeem-gift-membership"
                                permission={false}
                                showToastOnSuccess={false}
                                onSave={({ data }) => {
                                    setPersonalDetails(data);
                                    nextStep('OTP');
                                    scrollToTop();
                                }}
                                paramsData={{ email_hash: urlhash }}
                                initialValues={
                                    { 
                                        first_name: data.to.first_name,
                                        surname: data.to.surname,
                                        email: data.to.email,
                                    }
                                }
                                render={({ fetching }) => (
                                    <div className={style.form}>
                                        <div className={style.formRow}>
                                            <Text className="formTitle" text="personal DETAILS" />
                                        </div>
                                        <div className={style.formRow}>
                                            <Field
                                                name="first_name"
                                                component={Input}
                                                validate={required()}
                                                required={true}
                                                placeholder="Enter your first name"
                                                label="First name"
                                            />
                                        </div>
                                        <div className={style.formRow}>
                                            <Field
                                                name="surname"
                                                component={Input}
                                                validate={required()}
                                                label="Surname"
                                                required={true}
                                                placeholder="Enter your surname"
                                            />
                                        </div>
                                        <div className={`${style.formRow} ${style.bottomBorder}`}>
                                            <Field
                                                name="email"
                                                component={Input}
                                                validate={[required(), email()]}
                                                label="Email address"
                                                required={true}
                                                placeholder="Enter email address"
                                            />
                                        </div>
                                        <div className={style.formRow}>
                                            <Text className="formTitle" text="create your unique password" />
                                        </div>
                                        <div className={style.formRow}>
                                            <div className={style.formFieldRow}>
                                                <Field
                                                    name="password"
                                                    type={showPassword ? "text" : "password"}
                                                    component={Input}
                                                    validate={[required(), length({ minimum: 12 }), getPasswordValidationRegex()]}
                                                    placeholder="New Password"
                                                    label="Create password"
                                                    required={true}
                                                />
                                                <Link className={style.show} onClick={() => setShowPassword(!showPassword)}>
                                                    {showPassword ? "Hide" : "Show"}
                                                    <span className={`${style.dropDown} ${style.right}`}></span>
                                                </Link>
                                            </div>
                                        </div>
                                        <div className={style.formRow}>
                                            <div className={style.formFieldRow}>
                                                <Field
                                                    name="confirm_password"
                                                    type={showConfirm ? "text" : "password"}
                                                    component={Input}
                                                    validate={[required(), confirmation({ field: "password" })]}
                                                    placeholder="Confirm Password"
                                                    label="Confirm password"
                                                    required={true}
                                                />
                                                <Link className={style.show} onClick={() => setShowConfirm(!showConfirm)}>
                                                    {showConfirm ? "Hide" : "Show"}
                                                    <span className={`${style.dropDown} ${style.right}`}></span>
                                                </Link>
                                            </div>
                                        </div>
                                        <div className={`${style.formRow} ${style.checkBoxRow}`}>
                                            <Field
                                                name="terms"
                                                component={Checkbox}
                                                checkValue={1}
                                                validate={required()}
                                                link="terms-conditions"
                                                label="I agree to"
                                            />
                                            <Link className={style.termsLink} target="_blank" to={"terms-conditions"}>
                                                {"terms & conditions"}
                                            </Link>*
                                        </div>
                                        <div className={style.formRow}>
                                            <Field
                                                name="marketing_opt_in"
                                                component={Checkbox}
                                                checkValue={1}
                                                label="I agree to opt in for marketing purposes"
                                            />
                                        </div>
                                        <div className={style.formRow}>
                                            <Field
                                                name="subscribe"
                                                component={Checkbox}
                                                checkValue={1}
                                                label="Subscribe to the ww2HQ Newsletter"
                                            />
                                        </div>
                                        <div className={`${style.formRow} ${style.formSubmit}`}>
                                            <Button submit={true} fetching={fetching} label="NEXT" />
                                        </div>
                                    </div>
                                )}
                            />
                        );
                    }
                }}
            />
        </div>
    );
}
